<div class="flex journal-navigation-aside">
  <aside class="border-r border-t" [tuiNavigationAside]="true">
    @for (page of pages; track page.id) {
      <button
        class="link"
        routerLinkActive="active-link"
        [routerLink]="page.id"
        tuiButton
        size="s"
      >
        {{ page.name }}
      </button>
    }
  </aside>
  <main class="border-t w-full h-[90vh] overflow-hidden hide-scrollbar">
    <div class="p-4">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
